define(function(require,exports,module){
    var getType = require( "./type" );
    var IOS = require( "./lib/ios" );
    var Android = require( "./lib/android" );
    var Default = require( "./lib/default" );

    var sharedInstance;

    return {
        /**
         * Get/create a managed instance for easier 
         * usage in a large app-space.
         * @return {object} DeviceInteraction instance.
         */
        get    : function(){
            return sharedInstance = sharedInstance || this.create(getType());
        },
        /**
         * Create a new instance of a specific type.
         * @param  {string} [type]  DeviceInteraction type.  Defaults to config value form ./type.
         * @return {object}         DeviceInteraction instance.
         */
        create : function(config){
            var type = config && config.type;
    
            if(!type){
                type = getType(config).type;
            }
            
            switch(type){
                case 'ios': 
                case 'iphone': 
                case 'ipad': 
                    return new IOS({deepLinkPrefix: config && config.deepLinkPrefix})
                case 'android':
                    return new Android({deepLinkPrefix: config && config.deepLinkPrefix})
                default:
                    return new Default();
            }
        },
        /**
         * Get/set the shared instance type returned by .get.
         * @param   {string} [type] DeviceInteraction type.  Defaults to config value form ./type.
         * @return  {string} String descriptor of DeviceInteraction type.
         */
        type    : getType,
        IOSInteraction     : IOS,
        AndroidInteraction : Android,
        DefaultInteraction : Default
    }
});